var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroidAppDevelopmentServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 4.5,
    fill: "black",
    stroke: "#DC2418"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_395_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6562 15H17.3438C16.0488 15 15 16.0488 15 17.3438V42.6562C15 43.9512 16.0488 45 17.3438 45H42.6562C43.9512 45 45 43.9512 45 42.6562V17.3438C45 16.0488 43.9512 15 42.6562 15ZM43.2422 42.6562C43.2422 42.9785 42.9785 43.2422 42.6562 43.2422H17.3438C17.0215 43.2422 16.7578 42.9785 16.7578 42.6562V17.3438C16.7578 17.0215 17.0215 16.7578 17.3438 16.7578H42.6562C42.9785 16.7578 43.2422 17.0215 43.2422 17.3438V42.6562Z",
    fill: "#DC2418"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2383 23.8066L32.4023 23.5605L32.5664 23.3203L32.9297 22.7754C32.9766 22.7109 32.959 22.6172 32.8887 22.5762C32.8242 22.5293 32.7305 22.5469 32.6895 22.6172L32.3027 23.1973L32.1387 23.4434L31.9746 23.6895C31.4473 23.4844 30.8672 23.373 30.2461 23.373C29.6309 23.373 29.0449 23.4844 28.5176 23.6895L28.3535 23.4434L28.1895 23.1973L27.8027 22.6172C27.7559 22.5527 27.668 22.5352 27.6035 22.5762C27.5391 22.623 27.5215 22.7109 27.5625 22.7754L27.9258 23.3203L28.0898 23.5605L28.2539 23.8066C27.0234 24.3809 26.1855 25.4648 26.1855 26.7129H34.3125C34.3066 25.4648 33.4746 24.3809 32.2383 23.8066ZM28.5 25.5469C28.2598 25.5469 28.0664 25.3535 28.0664 25.1133C28.0664 24.873 28.2598 24.6797 28.5 24.6797C28.7402 24.6797 28.9336 24.873 28.9336 25.1133C28.9336 25.3535 28.7402 25.5469 28.5 25.5469ZM31.9805 25.5469C31.7402 25.5469 31.5469 25.3535 31.5469 25.1133C31.5469 24.873 31.7402 24.6797 31.9805 24.6797C32.2207 24.6797 32.4141 24.873 32.4141 25.1133C32.4199 25.3535 32.2266 25.5469 31.9805 25.5469Z",
    fill: "#DC2418"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2383 27.293H26.1738V28.0137V28.6055V33.6797C26.1738 34.1895 26.584 34.5996 27.0937 34.5996H27.7559C27.7324 34.6758 27.7207 34.7578 27.7207 34.8398V34.8867V35.1797V36.6797C27.7207 37.1602 28.1133 37.5527 28.5938 37.5527C29.0742 37.5527 29.4668 37.1602 29.4668 36.6797V35.1797V34.8867V34.8398C29.4668 34.7578 29.4551 34.6758 29.4316 34.5996H31.0488C31.0254 34.6758 31.0137 34.7578 31.0137 34.8398V34.8867V35.1797V36.6797C31.0137 37.1602 31.4063 37.5527 31.8867 37.5527C32.3672 37.5527 32.7598 37.1602 32.7598 36.6797V35.1797V34.8867V34.8398C32.7598 34.7578 32.748 34.6758 32.7246 34.5996H33.3867C33.8965 34.5996 34.3066 34.1895 34.3066 33.6797V28.6055V28.0137V27.2871H34.2422H26.2383V27.293Z",
    fill: "#DC2418"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7266 27.293C24.2461 27.293 23.8535 27.6855 23.8535 28.166V31.8926C23.8535 32.373 24.2461 32.7656 24.7266 32.7656C25.207 32.7656 25.5996 32.373 25.5996 31.8926V28.166C25.5937 27.6797 25.207 27.293 24.7266 27.293Z",
    fill: "#DC2418"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7598 27.293C35.2793 27.293 34.8867 27.6855 34.8867 28.166V31.8926C34.8867 32.373 35.2793 32.7656 35.7598 32.7656C36.2402 32.7656 36.6328 32.373 36.6328 31.8926V28.166C36.627 27.6797 36.2402 27.293 35.7598 27.293Z",
    fill: "#DC2418"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_395_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidAppDevelopmentServices);
export default __webpack_public_path__ + "static/media/androidAppDevelopmentServices.2c769b74ec2b647e010a6e560ed6b54a.svg";
export { ForwardRef as ReactComponent };